// check removeEventQueryParams in src/app/utils/index.ts
export enum ExpandedEventInUrl {
    event = 'e',
    type = 't',
    odd = 'o',
    sbValue = 'sb',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/enums.ts